/* eslint-disable arrow-body-style */
import { postMethod } from "../apiConfig";

export const loginApi = (data) => {
    return postMethod('/auth/sign-in', data);
};

export const resetPasswordApi = (data) => {
    return postMethod('/auth/reset-password', data);
};

export const checkOTPApi = (data) => {
    return postMethod('/auth/v1/verify-otp', data);
};

export const sendOTPApi = (data) => {
    return postMethod('/auth/v1/send-otp', data);
};

export const changePasswordApi = (data) => {
    return postMethod('/profile/update-password', data);
};

/* eslint-disable arrow-body-style */
